// extracted by mini-css-extract-plugin
export default {"background_wrapper":"BackgroundLayout_background_wrapper__-SzEw","wrapper":"BackgroundLayout_wrapper__WzshL","paddingBottom":"BackgroundLayout_paddingBottom__OZuvb"};